const ptTranslation = {
  goToSenecaLearning: "Ir para Seneca Learning 📚",
  continueWithProvider: "Continuar com {{provider}}",
  redirectBackToTheApp: "Redirecionar de volta para o aplicativo",
};

export default ptTranslation;
